import './MeterBarChartThresholds.css';
export var thresholdContainer = '_1kt6hkd0-3-5-0';